import React, { useState, useEffect, useContext } from "react";
import drupal from "../../apis/drupal";
import {
  renderImageGallery,
  renderBrandPartners,
  renderContentCards,
  renderCurrentPackageList,
  packageFiltering,
  renderFileList,
  renderDestGuide,
  renderLocations,
  loader,
} from "../../helpers";
import PersistedContext from "../../context/persistedContext";
import { BackgroundContext } from "../../context/BackgroundContext";
import Parser from "html-react-parser";
import _ from "lodash";
import Title from "../../elements/Title";
// import DealCard from "../../elements/DealCard";
import { Container, Row, Col } from "react-bootstrap";
import { default as BASE } from "../../config";
import { META } from "../../seo/meta";

const PackagePage = (props) => {
  const { packages } = useContext(PersistedContext);
  const { setImage } = useContext(BackgroundContext);
  const [premPage, setPremPage] = useState(false);
  const [data, setData] = useState([]);
  const title = props.match.params.title;

  useEffect(() => {
    fetchData();
  }, [title]);

  useEffect(() => {
    data && setLogo();
  }, [data]);

  const setLogo = () => {
    let image = data.field_vc_alt_background
      ? data.field_vc_alt_background
      : data.field_main_image;
    setImage(null, image);
  };

  const fetchData = async () => {
    //const res = await axios.get(`${process.env.REACT_APP_API}${resource}`);
    if (packages) {
      let pkg = _.find(packages, ["field_path", title]);

      const id = props.location.state
        ? props.location.state.params.pkgid
        : pkg.nid;

      const res = await drupal.get(`/campaigns/${id}`);
      //setImage(null, res.data[0].field_main_image);
      res.data[0].field_hide_related_list == 1 && setPremPage(true);
      setData(res.data[0]);
    }
  };

  const renderTvlBetween = (dates) => {
    const content = (
      <div className="travel-dates">
        <strong>For Travel Between: </strong>
        {dates.map((date, id) => (
          <span key={id}>{date}</span>
        ))}
      </div>
    );

    return content;
  };

  const packageList = (id, filteredPkgs, path) => {
    return (
      <Col sm="12" md="4">
        {renderCurrentPackageList(id, filteredPkgs, path)}
      </Col>
    );
  };

  const renderDealList = (view, premFlag, pgPath) => {
    return (
      view.length > 0 && (
        <Row className="mt-4">
          <div className="container w-100 mb-3 text-center">
            <h3 className="text-uppercase" title="Deals">
              Deals
            </h3>
          </div>
          {renderContentCards(view, premFlag, pgPath)}
        </Row>
      )
    );
  };

  if (!_.isEmpty(data)) {
    const dealUrl = BASE.CONFIG.SITE_BASE + props.location.pathname;
    const dates = data.field_valid_for_travel.split(",");
    const saleUntil = data.field_on_sale_until;
    const path = props.location.pathname;
    const basePath = props.match.path.split("/:");
    const filteredPackages = packageFiltering(packages, basePath[0]);
    const flyersTitle =
      data.field_viva_consumer_file_uploads_1 &&
      data.field_viva_consumer_file_uploads_1.split(",");
    const flyersPath =
      data.field_viva_consumer_file_uploads &&
      data.field_viva_consumer_file_uploads.split(",");
    const destGuideImage = data.field_brochure_image;
    const destGuideLink = data.field_brochure_link;

    const find = 'src="/sites/';
    const re = new RegExp(find, "g");
    const description = data.field_campaign_description.replace(
      re,
      'src="https://agents.vivaholidays.com.au/sites/'
    );

    //image carousel
    let gallery = data.field_image_gallery;
    let galleryCap = data.field_image_gallery_1;
    let galleryAlt = data.field_image_gallery_2;

    //partner logos
    let brandPartners = data.field_brand_partnership;
    let brandPartnerAlt = data.field_brand_partnership_1;

    return (
      <>
        <META
          title={Parser(data.title.trim())}
          description={data.field_campaign_description_1}
          image={data.field_main_image}
          url={dealUrl}
        />
        <Row>
          <Col>
            <Container>
              <Row>
                <Title title={Parser(data.title)} />
              </Row>
              <Row>
                <div className="mt-4 package-description">
                  {Parser(description)}
                </div>
              </Row>
              <Row>
                <div className="campaign-destination mt-1">
                  {renderLocations(data)}
                </div>
              </Row>
              {/* <Row>
              {saleUntil && (
                <div className="sale-dates mt-3">
                  <strong>On Sale Until:</strong> {data.field_on_sale_until}
                </div>
              )}
            </Row>
            <Row>
              {dates != "" && (
                <div className="travel-dates">
                  <strong>For Travel Between: </strong>
                  {dates.map((date, id) => (
                    <span key={id}>{date}</span>
                  ))}
                </div>
              )}
            </Row> */}
              <Row>{renderDealList(data.view, premPage, path)}</Row>
              {/*}<Row>
                <div className="mt-4 package-description">
                  {Parser(description)}
                </div>
              </Row>*/}
              <Row>
                {gallery && renderImageGallery(gallery, galleryCap, galleryAlt)}
              </Row>
              <Row>
                {destGuideLink &&
                  renderDestGuide(destGuideImage, destGuideLink)}
                {flyersTitle && renderFileList(flyersPath, flyersTitle)}
              </Row>
            </Container>
          </Col>
          {!premPage && packageList(data.nid, filteredPackages, basePath[0])}
          {brandPartners && renderBrandPartners(brandPartners, brandPartnerAlt)}
        </Row>
      </>
    );
  }

  return loader();
};

export default PackagePage;
